"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipCommonProps = void 0;

var _Tooltip = _interopRequireDefault(require("../../Tooltip"));

var TooltipCommonProps = {
  appendTo: _Tooltip["default"].propTypes['appendTo'],
  disabled: _Tooltip["default"].propTypes['disabled'],
  enterDelay: _Tooltip["default"].propTypes['enterDelay'],
  exitDelay: _Tooltip["default"].propTypes['exitDelay'],
  fixed: _Tooltip["default"].propTypes['fixed'],
  flip: _Tooltip["default"].propTypes['flip'],
  maxWidth: _Tooltip["default"].propTypes['maxWidth'],
  moveArrowTo: _Tooltip["default"].propTypes['moveArrowTo'],
  moveBy: _Tooltip["default"].propTypes['moveBy'],
  onHide: _Tooltip["default"].propTypes['onHide'],
  onShow: _Tooltip["default"].propTypes['onShow'],
  placement: _Tooltip["default"].propTypes['placement'],
  textAlign: _Tooltip["default"].propTypes['textAlign'],
  zIndex: _Tooltip["default"].propTypes['zIndex'],
  size: _Tooltip["default"].propTypes['size']
};
exports.TooltipCommonProps = TooltipCommonProps;